<template>
  <div>
    <div class="row mb-3">
      <div class="col">
        <h5>Select by topic:</h5>
      </div>
    </div>


    <div class="accordion" id="accordionExample">
      <template v-for="parent in themes">
        <div class="accordion-item" v-if="parent.poster_count > 0">
          <h2 class="accordion-header">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    :data-bs-target="'#collapseParent_' + parent.id" aria-expanded="false" aria-controls="collapseTwo">
              {{ parent.label }}
<!--              <span class="badge text-bg-secondary ms-2">{{ parent.poster_count }}</span>-->
            </button>
          </h2>
          <div :id="'collapseParent_' + parent.id" class="accordion-collapse collapse"
               data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="row row-cols-1 row-cols-md-2 g-4 h-100">
                <template v-for="themeItem in parent.children">
                  <div class="col" v-if="themeItem.poster_count > 0">
                    <button class="btn position-relative w-100 h-100"
                            v-bind:class="themeItem.id === selectedThemeComp ?'btn-success' : 'btn-outline-primary'"
                            v-on:click="selectTheme(themeItem.id)" data-bs-dismiss="offcanvas">
                      {{ themeItem.label }}
                      <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                  <template v-if="selectedTypeComp === null">
          {{ themeItem.poster_count }}
        </template>
                  <template v-if="selectedTypeComp === '1'">
                    {{ themeItem.poster_abstract_count }}
                  </template>
                  <template v-if="selectedTypeComp === '2'">
                    {{ themeItem.poster_clinical_count }}
                </template>
                <span class="visually-hidden">uploaded poster</span>
                </span>
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
  name: "GroupSelectionThemes",
  data: function () {
    return {
      // selectedParent: null,
      // selectedMiddle: null,
      // selectedTheme: null
    }
  },
  computed: {
    ...mapState(['themes', 'selectedType']),
    ...mapState('theme', ['firstLevelTheme', 'secondLevelTheme', 'selectedTheme']),
    selectedParent: {
      get() {
        return this.firstLevelTheme
      },
      set(id) {
        this.setFirstLevelTheme(id);
      }
    },
    selectedMiddle: {
      get() {
        return this.secondLevelTheme
      },
      set(id) {
        this.setSecondLevelTheme(id);
      }
    },
    selectedThemeComp: {
      get() {
        return this.selectedTheme
      },
      set(id) {
        this.setSelectedTheme(id);
      }
    },
    selectedTypeComp: {
      get() {
        return this.selectedType
      },
      set(id) {
        this.setSelectedType(id);
      }
    }
  },
  methods: {
    ...mapMutations(['setSelectedView', 'setSelectedType']),
    ...mapMutations('theme', ['setFirstLevelTheme', 'setSecondLevelTheme', 'setSelectedTheme']),
    selectTheme(theme_id) {
      this.selectedThemeComp = theme_id;
      this.$store.dispatch('TRACK_ACTION', {
        'value': theme_id,
        'action': 'view/theme',
        'source': process.env.VUE_APP_GOOGLE_ANALYTICS_NAME
      });
      this.setSelectedView('theme');
      this.$emit('push');
    }
  }
}
</script>

<style scoped>

</style>
